import Api from "./Api";

export default {
    getAllOptDashboard(payload) {
        let AllLeadList = Api().post(
            "Api_Dashboard/getDash.php",
            payload
        );
        return AllLeadList;
    },

};



// WEBPACK FOOTER //
// ./src/services/DashboardService.js